import { render } from "./notice-news.vue?vue&type=template&id=d403e470&scoped=true"
import script from "./notice-news.vue?vue&type=script&lang=js"
export * from "./notice-news.vue?vue&type=script&lang=js"

import "./notice-news.vue?vue&type=style&index=0&id=d403e470&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d403e470"]])

export default __exports__